import styled, { css } from 'styled-components'
import Segment, { disabledStyles } from 'components/Segment'

const fieldsetReset = css`
  border: 0;
  padding: 0;
  margin: 0;
  min-width: 0;
`

export const Wrapper = styled.fieldset`
  ${fieldsetReset};

  display: inline-flex;
  flex-shrink: 0;
  line-height: 0;
  margin-right: 8px;
`

export const Input = styled.input`
  appearance: none;
  margin: 0;

  &:disabled + ${Segment} {
    ${disabledStyles}
  }
`

export const TooltipShortcut = styled.div(
  ({ theme }) => css`
    color: ${theme.colors.foreground.primary[2]};
  `
)
